import React from 'react';
import { cn } from '../../utils/cn';

const cardVariants = {
  default: 'bg-white shadow-lg',
  hover: 'bg-white shadow-lg hover:shadow-xl md:hover:scale-105 transition-transform duration-300',
  bordered: 'bg-white border-2 border-gray-200',
};

/**
 * Reusable Card component wrapper
 *
 * @param {Object} props
 * @param {'default'|'hover'|'bordered'} props.variant - Card style variant
 * @param {ReactNode} props.children - Card content
 * @param {string} props.className - Additional CSS classes
 */
export const Card = ({
  variant = 'default',
  children,
  className,
  ...props
}) => {
  return (
    <div
      className={cn(
        'rounded-xl p-6 transition-all',
        cardVariants[variant],
        className
      )}
      {...props}
    >
      {children}
    </div>
  );
};
